<template>
  <wp-user-management-component />
</template>

<script>
import WpUserManagementComponent from '@/spa/components/board/wp-user-management/BoardWpUserManagement';

export default {
  name: 'WpUserManagementPage',
  components: {
    WpUserManagementComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/pages/operation/WpUserManagementPage.vue